import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getTeamShares, shareWithTeam } from '../../api/workEnvironmentQueries';
import type { ShareKind } from '../../api/workEnvironmentTypes';
import { ArchiveQueryKey } from './useArchiveQuery';

export const TeamSharesQueryKey = 'WORK_ENVIRONMENT_TEAM_SHARES';

export const useTeamSharesQuery = (surveyId: number) =>
  useQuery({
    queryKey: [TeamSharesQueryKey, surveyId],
    queryFn: () => getTeamShares(surveyId),
  });

export const useShareWithTeamMutation = (surveyId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (kind: ShareKind) => shareWithTeam(surveyId, kind),
    // Sharing is part of what the archive checklist looks for
    onSuccess: () =>
      Promise.all(
        [TeamSharesQueryKey, ArchiveQueryKey].map((key) =>
          queryClient.invalidateQueries({ queryKey: [key, surveyId] }),
        ),
      ),
  });
};
